import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import { handleErrorWithoutRedirect, handleResponse } from '@/services/api/utils/response.js'
import axios from 'axios'

const url = 'tfa'
const plural = 'tfas'
const single = 'tfa'

const twoFactorAuthenticatication = new ApiCore({
	index: true,
	create: true,
	url: url,
	plural: plural,
	single: single
})

twoFactorAuthenticatication.activateTfa = () => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/enable`)
		.then(handleResponse)
		.catch(handleErrorWithoutRedirect);
}

twoFactorAuthenticatication.deactivateTfa = (payload) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/disable`, payload)
		.then(handleResponse)
		.catch(handleErrorWithoutRedirect);
}

twoFactorAuthenticatication.generateTfa = () => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/secretkey`)
		.then(handleResponse)
		.catch(handleErrorWithoutRedirect);
}

twoFactorAuthenticatication.verifyTfa = (payload) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/verifytfa`,payload)
		.then(handleResponse)
		.catch(handleErrorWithoutRedirect);
}

twoFactorAuthenticatication.validateTfa = (payload) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/validate-tfa`, payload)
		.then(handleResponse)
		.catch(handleErrorWithoutRedirect);
}

twoFactorAuthenticatication.initiateResetTfa = (payload) => {
	return axios
		.post(`${apiProvider.BASE_URL}/initiate-reset-tfa`,payload)
		.then(handleResponse)
		.catch(handleErrorWithoutRedirect);
}

twoFactorAuthenticatication.resetTfa = () => {
	return axios
		.post(`${apiProvider.BASE_URL}/reset-tfa`)
		.then(handleResponse)
		.catch(handleErrorWithoutRedirect);
}

export default twoFactorAuthenticatication
